// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"36":"cfd69cb7","165":"75d304f6","553":"b8c43012","833":"773faaf5","885":"d5b1c120"}[chunkId] + ".css";
};